import { render, staticRenderFns } from "./PaiementLogos.vue?vue&type=template&id=231a6030&"
import script from "./PaiementLogos.vue?vue&type=script&lang=js&"
export * from "./PaiementLogos.vue?vue&type=script&lang=js&"
import style0 from "./PaiementLogos.vue?vue&type=style&index=0&id=231a6030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports